/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrimeDatatableParams } from '../../models/prime-datatable-params';
import { SystemFeatureViewModelPrimeDatatableResults } from '../../models/system-feature-view-model-prime-datatable-results';

export interface ListSystemFeatures$Params {
      body?: PrimeDatatableParams
}

export function ListSystemFeatures(http: HttpClient, rootUrl: string, params?: ListSystemFeatures$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFeatureViewModelPrimeDatatableResults>> {
  const rb = new RequestBuilder(rootUrl, ListSystemFeatures.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemFeatureViewModelPrimeDatatableResults>;
    })
  );
}

ListSystemFeatures.PATH = '/api/SystemSettings/ListSystemFeatures';
